import { Toggle } from "@/components/Toggle";
import type { Permission } from "@/contexts/UserContext";
import { useUser } from "@/hooks/useUser";

export function PermissionToggle({
  permission,
  allowed,
  denied,
  loading,
}: {
  readonly permission: Permission;
  readonly allowed: React.ReactNode;
  readonly denied: React.ReactNode;
  readonly loading?: React.ReactNode;
}) {
  const { hasPermission, user } = useUser();

  if (user === null && loading != null) {
    return loading;
  }

  return (
    <Toggle off={denied} on={allowed} showOn={hasPermission(permission)} />
  );
}
